/**
 * 租户后台管理员登录账号：手机号（国内/国际）、邮箱，或字母+数字且至少 8 位
 */

const EMAIL_RE = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/
const E164_RE = /^\+[1-9]\d{7,14}$/
const CN_MOBILE_RE = /^1[3-9]\d{9}$/
const CN_86_RE = /^86[1-9]\d{9}$/
const INTL_DIGITS_RE = /^[1-9]\d{7,14}$/
const ALNUM_RE = /^[a-zA-Z0-9]+$/

function isValidAlphanumericAccount(value) {
  if (value.length < 8) return false
  if (!ALNUM_RE.test(value)) return false
  if (!/[a-zA-Z]/.test(value)) return false
  return /\d/.test(value)
}

export function normalizeLoginAccount(raw) {
  if (raw == null) return null
  const trimmed = String(raw).trim()
  if (!trimmed) return null
  if (trimmed.includes('@')) {
    const email = trimmed.toLowerCase()
    return EMAIL_RE.test(email) ? email : null
  }
  const phone = trimmed.replace(/[\s-]/g, '')
  if (E164_RE.test(phone)) return phone
  if (CN_MOBILE_RE.test(phone)) return phone
  if (CN_86_RE.test(phone)) return '+' + phone
  if (INTL_DIGITS_RE.test(phone)) return phone
  if (isValidAlphanumericAccount(trimmed)) return trimmed
  return null
}

export function isValidLoginAccount(raw) {
  return normalizeLoginAccount(raw) != null
}

export const LOGIN_ACCOUNT_HINT =
  '登录账号须为手机号（如 13800138000、+85212345678）、邮箱，或字母+数字且至少 8 位（如 admin1234）'

export const LOGIN_ACCOUNT_INVALID_MSG = LOGIN_ACCOUNT_HINT
